import axios from 'axios'

import type { components } from '../constants/schema'

import type { BankName } from '../components/bankIcon/BankIcon'
import type { SecurityName } from '../components/securityIcon/SecurityIcon'

/**
 * 로그인 유저 출금 계좌 정보 (마스킹 O)
 * @returns MaskedWithdrawalAccountDto
 */
export const getWithdrawalAccount = async () => {
  return (await axios.get<components['schemas']['MaskedWithdrawalAccountDto']>('/user/current/withdrawalAccount')).data
}

/**
 * 로그인 유저 출금 계좌 정보 (마스킹 X)
 * @returns UnmaskedWithdrawalAccountDto
 */
export const getUnmaskedWithdrawalAccount = async () => {
  return (
    await axios.get<components['schemas']['UnmaskedWithdrawalAccountDto']>('/user/current/withdrawalAccount/unmask')
  ).data
}

/**
 * 로그인 유저 출금 계좌 생성
 * @param bankCode 은행코드
 * @param bankOwner 예금주명
 * @param account 계좌번호
 * @returns UnmaskedWithdrawalAccountDto
 */
export const createWithdrawalAccount = async (data: components['schemas']['WithdrawalAccountCreateDto']) => {
  try {
    return (
      await axios.post<components['schemas']['UnmaskedWithdrawalAccountDto']>('/user/current/withdrawalAccount', data)
    ).data
  } catch (error) {
    throw error
  }
}

/**
 * 로그인 유저 출금 계좌 수정
 * @param bankCode 은행코드
 * @param bankOwner 예금주명
 * @param account 계좌번호
 * @returns UnmaskedWithdrawalAccountDto
 */
export const updateWithdrawalAccount = async (data: components['schemas']['WithdrawalAccountUpdateDto']) => {
  try {
    return (
      await axios.put<components['schemas']['UnmaskedWithdrawalAccountDto']>('/user/current/withdrawalAccount', data)
    ).data
  } catch (error) {
    throw error
  }
}

interface GetWithdrawalAccountListResponse {
  bank: { code: string; name: BankName }[]
  securities: { code: string; name: SecurityName }[]
}
/**
 * 출금 계좌 은행/증권사 목록
 * @returns GetWithdrawalAccountListResponse
 */
export const getWithdrawalAccountList = async () => {
  return (await axios.get<GetWithdrawalAccountListResponse>('/nh/bankList')).data
}

export type { GetWithdrawalAccountListResponse }
